import ConnectionsContainer from './connections/connectionsPanelContainer';
import RecommendationsLoaderContainer from '../recommendations/recommendationsLoaderContainer';
import PanelHeader from '../sidebar/panelHeader/panelHeader';
import PanelCloseButton from '../sidebar/panelHeader/panelCloseButton';

export default function ArticleInfo() {
  return (
    <div className="sidebar-scroll-panel sidebar-panel-default-appearance">
      <PanelHeader title="Article info" closeButton={<PanelCloseButton>Hide</PanelCloseButton>} />
      <div className="sidebar-scroll-panel-body">
        <ConnectionsContainer />
        <RecommendationsLoaderContainer />
      </div>
    </div>
  );
}
